import { render, staticRenderFns } from "./serviceOrderCanItem.vue?vue&type=template&id=2fb8ba39&scoped=true&"
import script from "./serviceOrderCanItem.vue?vue&type=script&lang=ts&"
export * from "./serviceOrderCanItem.vue?vue&type=script&lang=ts&"
import style0 from "./serviceOrderCanItem.vue?vue&type=style&index=0&id=2fb8ba39&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2fb8ba39",
  null
  
)

export default component.exports